var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 33,
    viewBox: "0 0 47 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.85156,
    y: 4.51758,
    width: 37.3957,
    height: 3.76647,
    rx: 1.07613,
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.85156,
    y: 11.5117,
    width: 37.3957,
    height: 3.76647,
    rx: 1.07613,
    fill: "#C4C4C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.85156,
    y: 18.5078,
    width: 37.3957,
    height: 3.76647,
    rx: 1.07613,
    fill: "#C4C4C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.85156,
    y: 25.502,
    width: 37.3957,
    height: 3.76647,
    rx: 1.07613,
    fill: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.85156,
    y: 4.51758,
    width: 37.3957,
    height: 3.76647,
    rx: 1.07613,
    fill: "#C4C4C4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6.85156,
    y: 11.5117,
    width: 37.3957,
    height: 3.76647,
    rx: 1.07613,
    fill: "#C4C4C4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.85156,
    y: 18.5078,
    width: 37.3957,
    height: 3.76647,
    rx: 1.07613,
    fill: "#C4C4C4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6.85156,
    y: 25.502,
    width: 37.3957,
    height: 3.76647,
    rx: 1.07613,
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.625 6.66724L2.07173 9.35757H5.17827L3.625 6.66724ZM3.89403 13.6621L3.89403 9.08854H3.35597L3.35597 13.6621H3.89403Z",
    fill: "#606060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.625 27.116L5.17827 24.4256L2.07173 24.4256L3.625 27.116ZM3.35597 20.1211L3.35597 24.6947L3.89403 24.6947L3.89403 20.1211L3.35597 20.1211Z",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandNew);
export default __webpack_public_path__ + "static/media/Expand_New.cfb211f840b7cbf6b5c566bda849c637.svg";
export { ForwardRef as ReactComponent };